import { useTracking } from '@change-corgi/core-react/tracking';

import { useTopicPageData, useTopicPagePaginatedVictoriousPetitionsData } from '#src/app/pages/topic/pageContext';
import type { TopicVictoriousPetitionsItem } from '#src/app/pages/topic/pageContext';

type Result = ModelHookResult<
	{
		displayed: boolean;
		name: string;
		petitions: readonly TopicVictoriousPetitionsItem[];
		hasNextPage: boolean;
		nextPageLoading: boolean;
	},
	{
		loadMore: () => void;
	}
>;

export function useVictoriousPetitionsSection(): Result {
	const {
		data: { name },
	} = useTopicPageData();
	const track = useTracking();

	const {
		data: { hasNextPage, items, nextPageLoading },
		actions: { loadMore },
	} = useTopicPagePaginatedVictoriousPetitionsData();

	return {
		data: {
			petitions: items,
			displayed: items.length > 0,
			name,
			hasNextPage,
			nextPageLoading,
		},
		actions: {
			loadMore: () => {
				void track('topic_victories_show_more');
				loadMore();
			},
		},
	};
}
